







import { defineComponent, computed, ref, watch } from '@vue/composition-api'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import {
  PUBLISH_TEXTBOOK_ISSUE_LIVE,
  PUBLISH_TEXTBOOK_ISSUE_PREVIEW,
} from '@/shared/user/permissions'
import NavigationTabs from '@/components/custom/NavigationTabs.vue'

export default defineComponent({
  name: 'TextbookIssuesIndex',
  components: {
    NavigationTabs,
  },
  setup(props, { root }) {
    const tabsElement = ref(null)
    const { hasPermissionTo } = useUserStore().getters
    const tabs = computed(() => {
      const params = {
        textbookId: root.$route.params.textbookId,
        textbookIssueId: root.$route.params.textbookIssueId,
      }
      return [
        {
          name: root.$t('TextbookIssueMediaPage.title'),
          icon: 'mdi-folder-multiple-image',
          to: { name: 'TextbookIssueMediaPage', params },
        },
        {
          name: root.$t('TextbookIssuePages', params),
          icon: 'mdi-file-multiple',
          to: { name: 'TextbookIssuePages', params },
        },
      ].concat(
        hasPermissionTo.value(PUBLISH_TEXTBOOK_ISSUE_LIVE) ||
          hasPermissionTo.value(PUBLISH_TEXTBOOK_ISSUE_PREVIEW)
          ? [
              {
                name: root.$t('routes.PublishTextbookIssue', {
                  textbookIssueName: '',
                }),
                icon: 'mdi-publish',
                to: { name: 'PublishTextbookIssue', params },
              },
            ]
          : []
      )
    })
    const { activeTextbookIssue } = useTextbookStore().getters

    watch(
      () => activeTextbookIssue.value,
      () => {
        setTimeout(() => tabsElement.value.updateSlider(), 1000)
      }
    )

    return { tabs, tabsElement }
  },
})
